import { useCallback } from "react";

import { CloudFlowNodeType } from "@doitintl/cmp-models";

import { useCloudflow, useHasActiveCloudflowExecutions } from "../../hooks";
import { useCloudflowOperations } from "../Common/CloudflowOperationsProvider";
import { useNodeEdgeManager } from "../Common/NodeEdgeManagerProvider";

export const useCloudflowRunAction = (customerId: string, flowId: string) => {
  const { cloudflow } = useCloudflow(flowId);
  const { hasActiveExecutions } = useHasActiveCloudflowExecutions(flowId);
  const { triggerCloudflow, httpOperationLoading } = useCloudflowOperations();
  const { nodes } = useNodeEdgeManager();

  const hasWebhookTrigger = nodes.find((node) => node.type === CloudFlowNodeType.WEBHOOK_TRIGGER) !== undefined;

  const cantRunCloudflow =
    hasActiveExecutions ||
    hasWebhookTrigger ||
    cloudflow?.data.type === "demo" ||
    cloudflow?.data.type === "blueprint" ||
    httpOperationLoading;

  const runCloudflow = useCallback(() => triggerCloudflow(customerId, flowId), [customerId, flowId, triggerCloudflow]);

  let cantRunCloudflowReason: string | undefined;

  if (hasWebhookTrigger) {
    cantRunCloudflowReason = "This CloudFlow is triggered by a webhook and can't be run manually.";
  } else if (hasActiveExecutions) {
    cantRunCloudflowReason =
      "This CloudFlow is currently executing and cannot be triggered again until the current execution is complete.";
  }

  return {
    runCloudflow,
    cantRunCloudflow,
    cantRunCloudflowReason,
  };
};
